export const wordData = {
	// Be verbs ends with
	verbTokenRegex: ["'m", "'re", '’m', '’re'],

	// Be verbs exact match
	verbTokenMatch: ['am', 'is', 'are', 'was', 'were', 'be', 'been'],

	// Zombie nouns ends with
	nounTokenRegex: [
		'ion',
		'ions',
		'ism',
		'isms',
		'ity',
		'ities',
		'ment',
		'ments',
		'ness',
		'ance',
		'ances',
		'ence',
		'ences',
	],

	// Zombie nouns exclusions
	nounExceptionMatch: [
		'advance',
		'audience',
		'audiences',
		'billion',
		'city',
		'dance',
		'fence',
		'freelance',
		'glance',
		'hence',
		'ion',
		'lance',
		'lesion',
		'lion',
		'mention',
		'million',
		'nuance',
		'party',
		'pence',
		'pity',
		'prance',
		'prion',
		'prism',
		'schism',
		'science',
		'sciences',
		'sentence',
		'sentences',
		'stance',
		'trillion',
		'zion',
	],

	// Adverb ends with
	adjTokenRegex: [
		'ly',
		'al',
		'ive',
		'ful',
		'less',
		'ant',
		'ible',
		'able',
		'ic',
		'ary',
		'ac',
		'ous',
	],

	// Adverb exclusions
	adjectiveAdverbExceptionMatch: [
		'able',
		'agent',
		'ant',
		'aphrodisiac',
		'apothecary',
		'appeal',
		'apply',
		'arrival',
		'avowal',
		'bent',
		'cable',
		'cent',
		'congeal',
		'content',
		'continent',
		'dally',
		'deal',
		'decal',
		'dent',
		'derive',
		'dictionary',
		'disavowal',
		'dive',
		'drive',
		'early',
		'fable',
		'fabric',
		'family',
		'five',
		'fly',
		'functionary',
		'gal',
		'gent',
		'give',
		'grant',
		'halal',
		'handful',
		'heal',
		'hive',
		'imply',
		'intent',
		'jive',
		'lent',
		'less',
		'live',
		'logic',
		'magic',
		'maniac',
		'meal',
		'meant',
		'merchant',
		'monopoly',
		'mosaic',
		'music',
		'nary',
		'only',
		'pal',
		'pant',
		'pent',
		'percent',
		'plant',
		'potential',
		'prevent',
		'public',
		'rally',
		'rant',
		'real',
		'relent',
		'rely',
		'rent',
		'reveal',
		'revival',
		'rival',
		'rubric',
		'sable',
		'sally',
		'seal',
		'secretary',
		'sent',
		'south',
		'spent',
		'stable',
		'steal',
		'stent',
		'student',
		'supply',
		'survival',
		'table',
		'tally',
		'teal',
		'tent',
		'thrive',
		'topiary',
		'trident',
		'unless',
		'unruly',
		'vary',
		'veal',
		'vent',
		'want',
		'wary',
		'went',
	],

	// Preposition exact match
	prepositionTokenMatch: [
		'about',
		'above',
		'across',
		'after',
		'against',
		'along',
		'among',
		'around',
		'at',
		'before',
		'behind',
		'below',
		'beneath',
		'beside',
		'between',
		'beyond',
		'by',
		'down',
		'during',
		'for',
		'from',
		'in',
		'inside',
		'into',
		'near',
		'of',
		'off',
		'on',
		'onto',
		'out',
		'outside',
		'over',
		'past',
		'through',
		'throughout',
		'till',
		'to',
		'toward',
		'under',
		'underneath',
		'until',
		'up',
		'upon',
		'with',
		'within',
		'without',
	],

	// Waste Word Exact Match
	wasteWordTokenMatch: [
		'it',
		'this',
		'that',
		'there',
		'it’s',
		'that’s',
		'there’s',
		"it's",
		"that's",
		"there's",
	],
};
